import './OrderButton.scss';

export function OrderButton() {
  return (
    <a
      className="floating-order-button"
      href="https://www.cognitoforms.com/EniDesserts2/EniDessertsPreOrderForm"
    >
      <img className="image" src="OrderNow.png" alt="Order Now" />
    </a>
  );
}
